import { render, staticRenderFns } from "./OnlineServicesShared.vue?vue&type=template&id=276bb294&"
import script from "./OnlineServicesShared.vue?vue&type=script&lang=js&"
export * from "./OnlineServicesShared.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports